import { RECOMMENDATION_SOURCE_TYPES } from "../components/common/constants";

export const FORM_CONTEXT_ACTIONS = {
    EDIT: "edit",
    ADD: "add",
    ADD_SIMILAR: "add_similar",
    ADD_DUPLICATE: "add_duplicate",
    ADD_GEO: "add_geo",
    CONVERTING: "converting"
};

const ENTITY_RECOMMENDATION = "Recommendation";

export const resolveFormContextClientName = ({ projectClientName, recommendationClientName, queryClientId, clientsList }) => {
    if (projectClientName) return projectClientName;
    if (recommendationClientName) return recommendationClientName;
    if (queryClientId && Array.isArray(clientsList)) {
        const match = clientsList.find(c => String(c.id) === String(queryClientId));
        if (match?.name) return match.name;
    }
    return "";
};

export const getConvertSourceCode = () => {
    try {
        const raw = sessionStorage.getItem("currentRecommendationData");
        if (!raw) return "";
        const data = JSON.parse(raw);
        return data?.code || "";
    } catch {
        return "";
    }
};

/**
 * Builds banner copy for recommendation / new-CR add, edit, and convert flows.
 */
export const getFormContextBanner = ({
    section,
    selectedId,
    query = {},
    isCapitalRequest = false,
    crLabel = "Capital Request",
    clientName = "",
    sourceCode = ""
}) => {
    const isCrQuery = query.is_cr === "true";
    const isConverting =
        section === "add" &&
        !selectedId &&
        query.type === RECOMMENDATION_SOURCE_TYPES.CAPITAL_REQUEST &&
        Boolean(query.capital_request_id);

    let actionKey;
    let actionLabel;
    let entityLabel;
    let subtitle;

    if (section === "edit" || selectedId) {
        actionKey = FORM_CONTEXT_ACTIONS.EDIT;
        actionLabel = "Edit";
        entityLabel = isCrQuery || isCapitalRequest ? crLabel : ENTITY_RECOMMENDATION;
    } else if (isConverting) {
        actionKey = FORM_CONTEXT_ACTIONS.CONVERTING;
        actionLabel = "Converting";
        entityLabel = ENTITY_RECOMMENDATION;
        const codePart = sourceCode ? ` #${sourceCode}` : "";
        subtitle = `from ${crLabel}${codePart}`;
    } else {
        const type = query.type;
        if (type === RECOMMENDATION_SOURCE_TYPES.SIMILAR) {
            actionKey = FORM_CONTEXT_ACTIONS.ADD_SIMILAR;
            actionLabel = "Add Similar";
        } else if (type === RECOMMENDATION_SOURCE_TYPES.DUPLICATE_NO_CSP) {
            actionKey = FORM_CONTEXT_ACTIONS.ADD_DUPLICATE;
            actionLabel = "Add Duplicate - No CSP";
        } else if (type === RECOMMENDATION_SOURCE_TYPES.FULL_DUPLICATE) {
            actionKey = FORM_CONTEXT_ACTIONS.ADD_DUPLICATE;
            actionLabel = "Add Duplicate - Full";
        } else if (type === RECOMMENDATION_SOURCE_TYPES.GEO_HIERARCHY) {
            actionKey = FORM_CONTEXT_ACTIONS.ADD_GEO;
            actionLabel = "Add Same Geo Hierarchy";
        } else {
            actionKey = FORM_CONTEXT_ACTIONS.ADD;
            actionLabel = "Add New";
        }
        entityLabel = isCrQuery || isCapitalRequest ? crLabel : ENTITY_RECOMMENDATION;
    }

    return {
        actionKey,
        actionLabel,
        clientName: clientName || "",
        entityLabel,
        subtitle: subtitle || ""
    };
};

/** Plain-text line for the form header, e.g. "AdventHealth · Recommendation". */
export const formatFormContextMessage = banner => {
    if (!banner) return "";
    const shouldShowAction = banner.actionKey === FORM_CONTEXT_ACTIONS.CONVERTING;
    const parts = [shouldShowAction ? banner.actionLabel : "", banner.clientName, banner.entityLabel].filter(Boolean);
    let message = parts.join(" · ");
    if (banner.subtitle) {
        message = message ? `${message} (${banner.subtitle})` : banner.subtitle;
    }
    return message;
};
